/*
 * File Created: Tuesday, 16th May 2023 12:39:54 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Skeleton, Theme, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from 'react'
import { Colors } from "../../constants/color";

function Section({ reverse, id }: {reverse?: boolean, id: string}) {
  const theme: Theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: !reverse ? "row-reverse" : "row" },
        backgroundColor: parseInt(id, 10) % 2 !== 0 ? Colors.white : Colors.concrete,
        padding: {
          xs: theme.spacing(3, 1),
          sm: theme.spacing(3, 2),
          md: theme.spacing(12, 2),
          lg: theme.spacing(10, 10),
        },
      }}
    >
     <Skeleton
       variant="rectangular"
       sx={{
        width: { xs: "100%", md: "49%", lg: "48%" },
        height: { xs: '400px', sm: '631px', md: '415px', lg: '490px', xl: '680px' },
      }}
     />
     <Box
       sx={{
        width: { xs: "100%", md: "49%", lg: "48%" },
        padding: { xs: theme.spacing(4, 0), lg: theme.spacing(4, 0) },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
        // justifyContent: " center",
      }}
     >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          justifyContent: " center",
        }}
      >
        <Skeleton variant="rectangular" width="35%" height={20} />
        <Skeleton variant="rectangular" width="80%" height={40} />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          // backgroundColor: "green",
          // padding: 0,
          justifyContent: { xs: "flex-start", sm: "space-evenly" },
          // flexWrap: "wrap",
          gap: { xs: "6%", sm: 0 },
        }}
      >
        <Box
          sx={{
            width: {xs: "47%", sm: "32%"},
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Skeleton
           variant="rectangular"
            sx={{
              width: "100%",
              height: {
                xs: theme.typography.pxToRem(245),
                sm: theme.typography.pxToRem(318),
                md: theme.typography.pxToRem(205),
                lg: theme.typography.pxToRem(246),
                xl: theme.typography.pxToRem(380),
              },
              // cursor: "pointer",
              // position: "relative",
              // paddingBottom: theme.spacing(2.5),
            }}
          />
          <Skeleton variant="text" width="90%" sx={{fontSize: "18px"}} />
          <Skeleton variant="text" width="40%" />
        </Box>
        <Box
          sx={{
            width: {xs: "47%", sm: "32%"},
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Skeleton
           variant="rectangular"
            sx={{
              width: "100%",
              height: {
                xs: theme.typography.pxToRem(245),
                sm: theme.typography.pxToRem(318),
                md: theme.typography.pxToRem(205),
                lg: theme.typography.pxToRem(246),
                xl: theme.typography.pxToRem(380),
              },
              // cursor: "pointer",
              // position: "relative",
              // paddingBottom: theme.spacing(2.5),
            }}
          />
          <Skeleton variant="text" width="90%" sx={{fontSize: "18px"}} />
          <Skeleton variant="text" width="40%" />
        </Box>
      </Box>
     </Box>
    </Box>
  )
}

export default Section